export default __webpack_public_path__ + "images/45eca8793d52dcdf73cec60e68c12d70.svg";